import React, { useMemo } from 'react';
import { DriverReviewReason } from 'types/PropertyInsights';
import { ReviewNegativeReason, ReviewPositiveReason } from 'types/Review';
import ClapIcon from 'assets/icons/clap.svg?react';
import SignIcon from 'assets/icons/sign.svg?react';
import CashIcon from 'assets/icons/cash.svg?react';
import BroomIcon from 'assets/icons/broom.svg?react';
import NotLoadingIcon from 'assets/icons/notLoading.svg?react';
import AngryFaceIcon from 'assets/icons/angryFace.svg?react';
import TrashIcon from 'assets/icons/trashUnfilled.svg?react';
import CoinIcon from 'assets/icons/coin.svg?react';
import styles from './DriverReviewsWidget.module.css';

interface ReasonsProps {
    reasons: DriverReviewReason[];
}

const mapReasonsToIcons = {
    [ReviewPositiveReason.EASY_TO_USE]: <ClapIcon />,
    [ReviewPositiveReason.CLEAR_INSTRUCTIONS_AND_SIGNS]: <SignIcon />,
    [ReviewPositiveReason.FAIR_PRICE]: <CashIcon />,
    [ReviewPositiveReason.CLEAN_PARKING_LOT]: <BroomIcon />,
    [ReviewNegativeReason.TOOK_TOO_LONG_TO_LOAD]: <NotLoadingIcon />,
    [ReviewNegativeReason.DIFFICULT_TO_USE]: <AngryFaceIcon />,
    [ReviewNegativeReason.PARKING_LOT_NOT_CLEAN]: <TrashIcon />,
    [ReviewNegativeReason.SIGNAGE_NOT_CLEAR]: <SignIcon />,
    [ReviewNegativeReason.TOO_EXPENSIVE]: <CoinIcon />,
};

function Reasons({ reasons }: ReasonsProps): JSX.Element {
    const positiveReasons = useMemo(
        () =>
            reasons
                .filter((reason) => reason.reason_category === 'positive')
                .sort((a, b) => b.reason_percentage - a.reason_percentage),
        [reasons]
    );
    const negativeReasons = useMemo(
        () =>
            reasons
                .filter((reason) => reason.reason_category === 'negative')
                .sort((a, b) => b.reason_percentage - a.reason_percentage),
        [reasons]
    );

    return (
        <div className={styles.reasonsContainer}>
            <div className={styles.reasonsSection}>
                <h4>Why They Love Your Property</h4>
                {positiveReasons.map((reason) => (
                    <div key={reason.sk} className={styles.reasonItem}>
                        {mapReasonsToIcons[reason.reason]}
                        <p className={styles.reasonText}>{reason.reason}</p>
                        <p className={styles.reasonPercentage}>{reason.reason_percentage}%</p>
                    </div>
                ))}
            </div>
            <div className={styles.reasonsSection}>
                <h4>What Needs to Improve</h4>
                {negativeReasons.map((reason) => (
                    <div key={reason.sk} className={styles.reasonItem}>
                        {mapReasonsToIcons[reason.reason]}
                        <p className={styles.reasonText}>{reason.reason}</p>
                        <p className={styles.reasonPercentage}>{reason.reason_percentage}%</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Reasons;
